import { NgModule } from '@angular/core';
import { ErpWorkflowSharedModule } from './erpworkflow-shared.module';
import { ErpWorkflowRoutesModule } from './erpworkflow.routes';
import { ErpWorkflowService } from './service/erpworkflow.service';

/**
 * CoreModule for ERP Workflow.
 */
@NgModule( {
    imports: [
        ErpWorkflowSharedModule,
        ErpWorkflowRoutesModule
    ],
    declarations: [
    ],
    exports: [
        ErpWorkflowSharedModule
    ],
    providers: [
        ErpWorkflowService
    ],
} )

export class ErpWorkflowCoreModule {
}
